import { useTranslation } from "react-i18next";

export default function WaaromWij() {
  const { t } = useTranslation("inbraakschade-reparatie");
  const reasons = t("waaromWij.reasons", { returnObjects: true }) as Array<{
    num: string;
    title: string;
    text: string;
  }>;

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("waaromWij.h2")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-2xl p-6 md:p-8"
            >
              <span className="font-geist-mono font-bold text-3xl md:text-4xl text-brand-yellow block mb-4">
                {reason.num}
              </span>
              <h3 className="font-geist font-bold text-lg text-brand-text mb-2">
                {reason.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {reason.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}